import React from "react";

interface LogoWordmarkLoaderProps {
  visible?: boolean;
}

const LogoWordmarkLoader: React.FC<LogoWordmarkLoaderProps> = ({ visible = true }) => {
  if (!visible) return null;

  return (
    <div className="app-loading-fullscreen">
      <span
        className="app-loading-indicator app-loading-indicator--block"
        role="status"
        aria-live="polite"
      >
        ЗАРЕЖДА
      </span>
    </div>
  );
};

export default LogoWordmarkLoader;
